import { render, staticRenderFns } from "./OnlyDingding.vue?vue&type=template&id=283761ad&scoped=true&"
import script from "./OnlyDingding.vue?vue&type=script&lang=js&"
export * from "./OnlyDingding.vue?vue&type=script&lang=js&"
import style0 from "./OnlyDingding.vue?vue&type=style&index=0&id=283761ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283761ad",
  null
  
)

export default component.exports